
import { Component, Vue, Watch } from "vue-property-decorator";
import Authorization from "@/models/Authorization";

type PageState = "form" | "success" | "invalid";

@Component
export default class ResetPassword extends Vue {
  pageState: PageState = "form";
  password = "";
  confirmation = "";
  passwordTouched = false;
  confirmationTouched = false;
  showPassword = false;
  showConfirmation = false;
  isLoading = false;
  requestError = "";
  private requestId = 0;

  get passwordValid(): boolean {
    return this.password.length >= 6 && /^[a-zA-Z0-9]+$/.test(this.password);
  }

  get confirmationValid(): boolean {
    return this.passwordValid && this.confirmation.length > 0 && this.confirmation === this.password;
  }

  get passwordError(): string {
    if (!this.passwordTouched || !this.password) return "";
    if (!/^[a-zA-Z0-9]+$/.test(this.password)) return "請勿包含特殊字元，僅可使用英文字母與數字";
    if (this.password.length < 6) return "請輸入至少 6 個字元";
    return "";
  }

  get confirmationError(): string {
    if (!this.confirmationTouched || !this.confirmation) return "";
    return this.confirmationValid ? "" : "兩次輸入的密碼不一致";
  }

  get canSubmit(): boolean {
    return this.pageState === "form" && !this.isLoading && this.confirmationValid;
  }

  @Watch("$route.query", { immediate: true, deep: true })
  onQueryChanged(): void {
    this.requestId += 1;
    this.isLoading = false;
    this.requestError = "";
    this.password = "";
    this.confirmation = "";
    this.passwordTouched = false;
    this.confirmationTouched = false;
    this.pageState = this.hasLinkParameters() ? "form" : "invalid";
  }

  private hasLinkParameters(): boolean {
    const { userId, token } = this.$route.query;
    return typeof userId === "string" && userId.trim().length > 0 &&
      typeof token === "string" && token.trim().length > 0;
  }

  async send(): Promise<void> {
    if (!this.canSubmit) return;
    if (!this.hasLinkParameters()) {
      this.pageState = "invalid";
      return;
    }

    const requestId = ++this.requestId;
    const { userId, token } = this.$route.query;
    this.isLoading = true;
    this.requestError = "";

    try {
      const status = await new Authorization().resetPassword(userId as string, token as string, this.password);
      if (requestId !== this.requestId) return;

      if (status === 204 || status === 401 || status === 403) {
        this.password = "";
        this.confirmation = "";
        this.pageState = status === 204 ? "success" : "invalid";
      } else {
        this.requestError = "送出失敗，請稍後再試。已保留輸入的密碼。";
      }
    } catch (_error) {
      if (requestId !== this.requestId) return;
      this.requestError = "目前無法連線，請檢查網路後再試。已保留輸入的密碼。";
    } finally {
      if (requestId === this.requestId) this.isLoading = false;
    }
  }
}
